import { render } from "./MainStores.vue?vue&type=template&id=2ae66b0c&scoped=true"
import script from "./MainStores.vue?vue&type=script&lang=js"
export * from "./MainStores.vue?vue&type=script&lang=js"

import "./MainStores.vue?vue&type=style&index=0&id=2ae66b0c&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae66b0c"]])

export default __exports__